import $ from 'jquery';
import Cookies from 'js-cookie'

const object = orecaObject

const jsContainer = () => {
    const container = $('.js-container');

    if (container.length) {
        const bodyWidth = $('body').outerWidth();
        container.css({
            width: bodyWidth,
            marginLeft: `calc(${-bodyWidth / 2}px + 50%)`,
        });
    }
};

const jsContainerAccompaniment = () => {
    const containerAccompaniment = $('.js-container-accompaniment');

    if (containerAccompaniment.length) {
        const bodyWidth = $('body').outerWidth();

        let bodyWidthFinal = bodyWidth - 440;
        let marginLeftFinal = `calc(${(-bodyWidth + 440) / 2}px + 50%)`;
        if (bodyWidth < 1545) {
            bodyWidthFinal = bodyWidth;
            marginLeftFinal = `calc(${-bodyWidth / 2}px + 50%)`;
        }
        containerAccompaniment.css({
            width: bodyWidthFinal,
            marginLeft: marginLeftFinal,
        });
    }
};

$(window)
    .on('resize', function () {
        jsContainer();
        jsContainerAccompaniment();
    })
    .trigger('resize');

$('.vn-btn-terms button').on('click', function (e) {
    e.preventDefault();
    const button = $(this);
    const href = button.attr('data-url');

    window.location.href = href;
});

$('a[href="#cookies"]').on('click', (e) => {
    e.preventDefault();
    window.openAxeptioCookies();
});

$('.go-top').on('click', function () {
    document.getElementsByTagName('html')[0].scrollIntoView({ behavior: 'smooth' })
})

$('.go-down').on('click', function () {
    document.getElementsByClassName('entry-content')[0].scrollIntoView({ behavior: 'smooth' })
})


$('.vn-excerpt__more').on('click', function () {
    const button = $(this)
    const button_parent = button.parents('.vn-excerpt')

    if (button_parent.hasClass('vn-excerpt--active')) {
        button.html(object.readmore)
    } else {
        button.html(object.readless)
    }

    button_parent.toggleClass('vn-excerpt--active')
})

$('#ne-button').on('click', function () {
    $('#ne-button').toggleClass('ne-button--active')
    $('#ne-modal').toggleClass('ne-modal--active')

    Cookies.set('stickyNEActive', 1)
})

$('#ne-close-modal').on('click', function () {
    $('#ne-button').toggleClass('ne-button--active')
    $('#ne-modal').toggleClass('ne-modal--active')

    Cookies.set('stickyNEActive', 0)
})